import gql from 'graphql-tag';
import { CampaignType } from '../../shared/types';
import { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';

export const CREATE_CAMPAIGN = gql`
    mutation createCampaign($item: CreateCampaignInput) {
        createCampaign(item: $item) {
            _id
            articleLink
        }
    }
`;

export interface CreateCampaignInput {
    articleId: string;
    campaignType: CampaignType;
}

// We want to create a campaign and generate the sharing url when the user clicks on the share button.
// The react-share library does not allow the url to be update after clicking.
// This hook is a work around.
// It captures the first click and prevents it from propagating to the react-share component.
// Then it creates a campaign and generates a link.
// Finally it 'clicks' on the component programatically once that link is ready.
export const useSocialShare = (
    campaignType: CampaignType,
    articleId: string,
    initialUrl = 'none'
) => {
    const [url, setUrl] = useState(initialUrl);
    const [createCampaign] = useMutation<any, { item: CreateCampaignInput }>(
        CREATE_CAMPAIGN
    );
    const ref = useRef(null);

    useEffect(() => {
        if (url === initialUrl) return;
        if (!ref.current) throw Error('Social media el ref not found');
        const element: HTMLElement = ref.current as any;
        element.click();
    }, [url, initialUrl]);

    const onClick = async (e: React.MouseEvent) => {
        if (url !== initialUrl) return;
        e.stopPropagation();
        const { data } = await createCampaign({
            variables: { item: { articleId, campaignType } },
        });
        setUrl(data.createCampaign.articleLink);
    };

    return {
        ref,
        url,
        onClick,
    };
};
